import { Injectable } from '@angular/core';
import { LogService } from '../../../shared/services/log.service';
import { ToastService } from '../../../shared/services/toastr.service';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { updateError, updatePopover, updateSaving } from './register_actions_creator';
import { RegisterState } from './register_state';
import { UserService } from '../../../shared/services/user.service';
import { Credentials } from '../../../shared/models/credentials';
import { RedirectService } from '../../../shared/services/redirect.service';
import { ENV } from '../../../environment';
import { SIGNUP_PLATFORM_PATH } from '../../../install/shared/navigation/constants';
import { Router } from '@angular/router';
import { FlowTrackingService } from '../../shared/services/flow-tracking.service';
import { take } from 'rxjs/operators';
import { AuthService } from '@yotpo-ui/core';

@Injectable()
export class RegisterEffectsService {

    constructor(private logger: LogService,
        private toastrService: ToastService,
        private translate: TranslateService,
        private store: Store<RegisterState>,
        private authenticationService: AuthService,
        private userService: UserService,
        private redirectService: RedirectService,
        private router: Router,
        private flowTrackingService: FlowTrackingService
    ) { }

    saveData(registerState: RegisterState) {
        if (!registerState.captchaToken && ENV.ShowCaptcha === true) {
          this.handleError('CAPTCHA token is missing.');
          return;
        }
        let createUserArgs = {...registerState.user, capcha_token: registerState.captchaToken};
        let useAccountSystem = createUserArgs.use_account_system;
        this.userService.createUser(createUserArgs, useAccountSystem).pipe(take(1)).subscribe(
            (response: any) => {
              if (response.errors) {
                this.dispatchError(response);
              } else {
                if (response.redirect_to) {
                  if (response.appkey && response.utoken) {
                    this.authenticationService.setCredentials(new Credentials(response.appkey, response.utoken));
                  }
                  this.redirectService.navigateOrRedirectTo(response.redirect_to);
                } else {
                  response = response.response;
                  if (response.store_info.app_key && response.admin_info.token) {
                    this.authenticationService.setCredentials(new Credentials(response.store_info.app_key, response.admin_info.token));
                    this.router.navigateByUrl(SIGNUP_PLATFORM_PATH);
                    this.flowTrackingService.StepOneCompleted();
                  }
                }
              }
            }, response => {
                this.handleError(response);
            });
    }

    private handleError(response) {
        this.dispatchError(response);
        this.logger.error(response);
        let errMsg = this.translate.instant('SIGNUP.REGISTER.SAVE_FAILED');
        if (!response.message.includes('Exceptions::EmailTaken')) {
          this.toastrService.error('signup', 'RegisterEffectsService: saveData', errMsg, response);
        }

        if (response.message.includes('Exceptions::EmailTaken')) {
          this.flowTrackingService.EmailTaken();
        }
    }

    private dispatchError(response) {
      let errors = this.translateErrorMessages(response);
      this.store.dispatch(updateError({error: errors}));
      this.store.dispatch(updatePopover({popover: true}));
      this.store.dispatch(updateSaving({saving: false}));
    }

    private translateErrorMessages(response) {
        let errors = {
            email: '',
            password: ''
        };
        if ((response.errors && response.errors['error_email']) ||
          (response.message && response.message.includes('Exceptions::EmailTaken'))) {
            errors.email = this.translate.instant('SIGNUP.REGISTER.VALIDATION.EMAIL.TAKEN');
        }
        if ((response.errors && response.errors['error_password']) ||
          (response.message && response.message.includes('Exceptions::WeakPassword'))) {
            errors.password = this.translate.instant('SIGNUP.REGISTER.VALIDATION.PASSWORD.WEAK');
        }
        return errors;
    }
}
